import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import { ReactNode } from "react";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export const TableDeleteItemsPopover = ({
  anchor,
  onClose,
  deleteItems,
  selectedItems,
  warningContent,
  alternativeAction,
  itemLabel,
}: {
  anchor: HTMLElement | null;
  onClose: () => void;
  deleteItems: () => void;
  selectedItems: any[];
  /** Label for the item type, e.g. "User", "Asset", "Ticket". Defaults to "Item". */
  itemLabel?: string;
  /** Optional custom warning rendered above the action buttons. */
  warningContent?: ReactNode;
  /** Optional alternative action shown alongside Delete (e.g. "Change Enrollment Status"). */
  alternativeAction?: { label: string; onClick: () => void };
}) => {

  const handleDeleteItems = () => {
    deleteItems();
    onClose();
  };

  const singularLabel = itemLabel ?? "Item";
  const pluralLabel = singularLabel.endsWith("s") ? singularLabel : `${singularLabel}s`;
  const countLabel = selectedItems.length === 1 ? singularLabel : pluralLabel;

  return (
    <Dialog
      className="table-controls-popup"
      open={!!anchor}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          maxWidth: 440,
        },
      }}
    >
      {warningContent ? (
        <>
          <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pb: 1 }}>
            <WarningAmberIcon color="warning" />
            Confirm Deletion
          </DialogTitle>
          <DialogContent sx={{ pt: 0 }}>
            {warningContent}
          </DialogContent>
        </>
      ) : (
        <DialogContent>
          Are you sure you want to delete the selected items?
        </DialogContent>
      )}
      <Divider />
      <DialogActions sx={{ flexWrap: "wrap", gap: 1, p: 2 }}>
        <Button
          sx={{ flexGrow: 1 }}
          onClick={onClose}
          variant="outlined"
        >
          Cancel
        </Button>
        {alternativeAction && (
          <Button
            sx={{ flexGrow: 1 }}
            variant="contained"
            color="primary"
            onClick={() => { alternativeAction.onClick(); onClose(); }}
          >
            {alternativeAction.label}
          </Button>
        )}
        <Button
          sx={{ flexGrow: 1, borderRadius: 2 }}
          variant="contained"
          color="error"
          onClick={handleDeleteItems}
        >
          Delete {selectedItems.length} {countLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TableDeleteItemsPopover;
